import {
  Card,
  CardContent,
  Typography,
  Chip,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const ENV_COLORS: Record<string, string> = {
  production: '#d32f2f',
  hml: '#1976d2',
  development: '#388e3c',
  staging: '#f57c00',
  training: '#7b1fa2',
  cron: '#00838f',
};

interface EnvironmentBreakdownCardProps {
  byEnvironment: Record<string, number>;
}

export const EnvironmentBreakdownCard = ({
  byEnvironment,
}: EnvironmentBreakdownCardProps) => {
  const classes = useStyles();
  const entries = Object.entries(byEnvironment);

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.content}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Distribuição por Ambiente
        </Typography>
        {entries.length === 0 ? (
          <Typography color="textSecondary" variant="body2">
            Nenhum dado disponível
          </Typography>
        ) : (
          <div className={classes.chips}>
            {entries.map(([env, count]) => (
              <Chip
                key={env}
                label={`${env}: ${count}`}
                style={{
                  backgroundColor: ENV_COLORS[env] ?? '#757575',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                }}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
